import ModulesBento from "@/components/ModulesBento";
import PricingBlock from "@/components/PricingBlock";
import EditorialMarquee from "@/components/EditorialMarquee";
import { motion } from "framer-motion";
import { useTrackView } from "@/lib/trackInterest";

export default function ModulesPage() {
  useTrackView("modules", "Modules · all 8");
  return (
    <main className="pt-32 md:pt-40">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
          className="grid grid-cols-12 gap-y-8"
        >
          <div className="col-span-12 md:col-span-8">
            <div className="section-tag mb-4">§ The 8 Modules</div>
            <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.88] tracking-tighter">
              Eight <span className="italic text-[#B45309]">modules</span>.
              <br />One healing.
            </h1>
          </div>
          <div className="col-span-12 md:col-span-4 flex flex-col justify-end gap-6">
            <p className="text-[#78716C] text-lg leading-relaxed">
              Unlock all 8 with one secure card purchase — instant, lifetime access, right here on the site. Bulk licensing available for your workforce.
            </p>
            <div className="flex items-center gap-4" data-testid="modules-guide-chip">
              <img src="/author/avatar.jpg" alt="Rich Culmer" className="w-14 h-14 rounded-full object-cover border-2 border-[#F59E0B]/70" />
              <div>
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#B45309]">Your guide</div>
                <div className="font-display text-xl">Rich Culmer — in his own voice.</div>
              </div>
            </div>
          </div>
        </motion.div>
      </section>
      <EditorialMarquee />
      <ModulesBento heading={false} />
      <PricingBlock />
    </main>
  );
}
